import { TableV2, TableV2Props } from '@anytag/shared-atoms';

export type AnalyticsCompareOverviewTableProps<TData, TValue> = TableV2Props<TData, TValue>;
export const AnalyticsCompareOverviewTable = <TData, TValue>({
  hasBorder = false,
  noTopBorderRadius = true,
  ...restProps
}: AnalyticsCompareOverviewTableProps<TData, TValue>) => (
  <TableV2 hasBorder={false} rowHeight="62px" noTopBorderRadius {...restProps} />
);
